import { Button } from '@rocketlane/ui';
import styled from 'styled-components';
export const DeleteButton = styled(Button).attrs({
    variant: 'ghost',
    type: 'button'
})`
  color: var(--black-100);
  &:hover,
  &:focus {
    color: var(--red-60);
  }
  &:disabled:focus,
  &:disabled:hover {
    color: var(--black-60);
  }
`;
